<template>
	<div class="provider">
		<template v-if="loadedAllProviders">
			<ProviderHeader v-if="provider" :provider="provider">
			</ProviderHeader>
			<router-view
				v-bind:provider="provider">
			</router-view>
		</template>
		<template v-else>
			<Loading text="Loading care provider..."></Loading>
		</template>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import Loading from '@/module/component/Loading'
import ProviderHeader from './Header'

export default {
	name: 'home',

	computed: {
		...mapState('provider', [
			'loading',
			'provider',
			'loadedAllProviders'
		]),
		...mapGetters(['getUserType']),
	},

	mounted() {
		this.$emit('tabColor', this.getUserType === 'observer' ? '#1B98CD' : '#2d3e4f')
	},

	beforeRouteUpdate(to, from, next) {
		this.$emit('tabColor', this.getUserType === 'observer' ? '#1B98CD' : '#2d3e4f')
		next()
	},
	beforeRouteLeave(to, from, next) {
		this.$emit('tabColor')
		next()
	},

	components: {
		ProviderHeader,
		Loading
	}
}
</script>

<style lang="scss" scoped>
.landing {
	padding: 10px 15px;
	background: #f0f0f0;
}
.metric {
	text-align: center;
	h1 {
		font-size: 50px;
	}
	p {
		font-size: 18px;
	}
}
.provider {
	background: #fafafa;
}
</style>
